module.exports = __webpack_public_path__ + "static/media/STPProjectPreview2w1100@2x.95769595.jpg";